// Shareable replays: pack { lab, seed, decisions } into a ?replay= query
// parameter so any execution can travel as a plain link. The payload is
// base64url JSON; decoding never throws, it returns null instead.

// Unicode-safe base64url without TextEncoder so the helpers also run under
// jsdom and older browsers.
function toBase64Url(json) {
  const binary = unescape(encodeURIComponent(json));
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(token) {
  const padded = token.replace(/-/g, '+').replace(/_/g, '/');
  return decodeURIComponent(escape(atob(padded)));
}

export function encodeReplay(labId, seed, decisions) {
  return toBase64Url(JSON.stringify({ v: 1, lab: labId, seed, decisions }));
}

export function decodeReplay(token) {
  try {
    const parsed = JSON.parse(fromBase64Url(token));
    if (!parsed || parsed.v !== 1 || typeof parsed.lab !== 'string') return null;
    if (typeof parsed.seed !== 'number' || !Array.isArray(parsed.decisions)) return null;
    return { labId: parsed.lab, seed: parsed.seed, decisions: parsed.decisions };
  } catch (e) {
    return null;
  }
}

export function parseReplayFromLocation(location) {
  const params = new URLSearchParams(location.search || '');
  const token = params.get('replay');
  if (!token) return null;
  return decodeReplay(token);
}

export function buildReplayUrl(location, labId, seed, decisions) {
  const url = new URL(location.href);
  url.searchParams.set('replay', encodeReplay(labId, seed, decisions));
  url.hash = 'sandbox';
  return url.toString();
}
